module.exports = __webpack_public_path__ + "img/teamtip_neue_saison-de-600x200.8bced54a.png";